import {
    REQUEST_ENTERPRISE_CARD_PAY,
    SUCCESS_ENTERPRISE_CARD_PAY,
    FAILURE_ENTERPRISE_CARD_PAY
} from './constants';
import { PATH } from '../../constants/path';
import { HTTP_METHOD_POST } from '../../constants/httpMethod';

import { CALL_API } from '../../middlewares/api';

export function payWithEnterpriseCard(userInfo, partnerId, orderId) {
    return {
        [CALL_API]: {
            endpoint: `/enterprisecard/pay`,
            method: HTTP_METHOD_POST,
            body: { partnerId, ...userInfo, orderId },
            types: [
                REQUEST_ENTERPRISE_CARD_PAY,
                SUCCESS_ENTERPRISE_CARD_PAY,
                FAILURE_ENTERPRISE_CARD_PAY
            ],
            successCallback: response => {
                window.location.href = `${PATH.EBON_CONFIRMATION_PATH}?orderId=${orderId}`;
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/enterprisecard/actions.js